import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { MOBILE_BREAKPOINT } from '../../../../../submission-details-view.constants';

export const providerInfoBadgeStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  background-color: ${theme.colors.primary5};
  padding: ${theme.spacing(0.5, 1)};
  border-radius: ${theme.borderRadius.small};

  svg {
    flex-shrink: 0;
  }

  .provider-name {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @container submission-details-view (max-width: 950px) {
    .provider-name {
      max-width: 100px;
    }
  }

  @container submission-details-view (max-width: 850px) {
    .provider-name {
      max-width: 70px;
    }
  }

  @container submission-details-view (max-width: ${MOBILE_BREAKPOINT}px) {
    overflow: hidden;

    .provider-name {
      max-width: unset;
      overflow: hidden;
      font-size: ${theme.font.size.medium};
    }
  }
`;

export const providerInfoBadgeButtonStyle = [
  providerInfoBadgeStyle,
  css`
    > span {
      display: inline-flex;
      align-items: center;
      gap: ${theme.spacing(0.5)};
    }

    @container submission-details-view (max-width: ${MOBILE_BREAKPOINT}px) {
      > span {
        overflow: hidden;
      }
    }
  `,
];
